export enum PROFILE_TABS {
  DASHBOARD = 0,
  INFORMATION = 1,
  SCHEDULE = 2,
  CONTACTS = 3,
  BEHAVIOR_HISTORY = 4,
  INCIDENTS_HISTORY = 5,
  ACCOUNTS = 6,
};
